import type * as ents from '@attain-apps/entities'
import type { PartialId } from '@attain-apps/string-builder'

import type { DocumentKey } from '../../kb-document-uploads'

/**
 * Placeholder used in place of a real {@link ents.core.dms.data.Record.Id}
 * while a record is still being created (no id exists yet).
 */
export const DRAFT_RECORD_ID = 'draft'

/**
 * Builds the {@link DocumentKey} for one Files-typed attribute on one DMS
 * record. Deterministic so the same key can be recomputed both before a
 * record is saved (to stage a selection) and afterwards (to look the
 * selection back up once the record has a real id).
 */
export function documentKeyFor(params: {
  readonly attributeId: PartialId
  readonly modelId: ents.core.dms.models.ForRecord.Id
  readonly recordId: ents.core.dms.data.Record.Id | undefined
}): DocumentKey {
  return `dms-record:${params.modelId}:${params.recordId ?? DRAFT_RECORD_ID}:${params.attributeId}`
}
